import React, { useRef } from "react";
import {
  EmptyLabelButton,
  EmptyTableLAbel,
  EmptyTableWrapper,
} from "./EmptyTableComponentStyled";
import { UploadSimple } from "@phosphor-icons/react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useUploadNotification } from "../../context/UploadNotificationContext";
import { useCancellableUpload } from "../../hooks/useCancellableUpload";
import PropTypes from "prop-types";
import {
  createUploads,
  createObjectURL,
  handleUploadSuccess,
  handleUploadFailure,
  processFiles,
  useUploadUtils,
  extractFilesFromDrop
} from "../../utils/uploadUtils";

const EmptyTableComponent = ({
  setShowDragNotification
}) => {
  const fileInputRef = useRef(null);
  const { dispatch, updateCount } = useUploadUtils();
  const { id } = useParams();
  const location = useLocation();
  const {matterDetails } = useSelector((state) => state.matterDetails);
  
  const {
    uploads,
    addUpload,
    addUploadAbortController,
    updateUpload,
    removeUpload,
    cancelUpload,
    addFailedUpload,
    markUploadCompleted,
    clearCompletedUploadIds,
    isUploadCancelled,
  } = useUploadNotification();
  
  const { uploadFile, uploadFileToSignedUrl } = useCancellableUpload();
  
  const handleButtonClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleProcessFiles = (files) => {
    if (!matterDetails?.id || !(matterDetails?.sf_id || matterDetails?.sf_matter_id)) return;
    const urlIds = location.pathname.split("/matter/")[1]?.split("/") ?? [];
    const lastSegment = urlIds.at(-1);
    const uniqueId = lastSegment?.startsWith("F") ? lastSegment : null;
    const setCurrentPage = null; // EmptyTable doesn't need this
    
    processFiles({
      files,
      createUploads,
      addUpload,
      setShowDragNotification,
      addUploadAbortController,
      uploadFile,
      uploadFileToSignedUrl,
      createObjectURL,
      handleUploadSuccess,
      handleUploadFailure,
      matterDetails,
      id,
      uniqueId,
      updateUpload,
      uploads,
      removeUpload,
      cancelUpload,
      addFailedUpload,
      markUploadCompleted,
      clearCompletedUploadIds,
      isUploadCancelled,
      setErrorToastMsgAndShow: null,
      setisLoading: null,
      setCurrentPage,
      dispatch
    });
  };
  

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles?.length) return;
    updateCount();
    const fileArray = Array.from(selectedFiles);
    handleProcessFiles(fileArray);
    e.target.value = ""; // Reset so same file(s) can be selected again
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const { files } = await extractFilesFromDrop(e);
    handleProcessFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <EmptyTableWrapper onDrop={handleDrop} onDragOver={handleDragOver}>
      <UploadSimple size={36} />
      <EmptyTableLAbel>
        Drag your files or folders here or{" "}
        <EmptyLabelButton 
          onClick={handleButtonClick}
          style={{ 
            opacity: 1,
            cursor: 'pointer'
          }}
        >
          click to upload
        </EmptyLabelButton>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </EmptyTableLAbel>
    </EmptyTableWrapper>
  );
};

export default EmptyTableComponent;
EmptyTableComponent.propTypes = {
  setShowDragNotification: PropTypes.func
};